<app-cyclops-nav></app-cyclops-nav>

<!-- Solutions Page Header with Background Video -->
<section class="cyclops header" id="home">
  <div class="header5-content">
    <div class="cyclops-header bg video-header">
      <!-- 🎥 Background Video -->
      <video autoplay muted loop playsinline class="video-bg">
        <source src="assets/images/7.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="video-dark-overlay"></div>

      <!-- Overlay Content -->
      <div class="video-overlay">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="center-text text-center" style="justify-content: center;">
                <div>
                  <h1>
                    <span class="bold-text">Who we serve</span>
                  </h1>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Image Carousel Section (below video header) -->
<section class="cyclops-slider-wrapper py-4">
  <div class="container" style="max-height: 600px">
    <owl-carousel-o
      class="default-dots cyclops-slider"
      [options]="{
        loop: true,
        dots: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 4000,
        nav: false
      }"
    >
      <!-- <ng-template carouselSlide>
        <img
          src="assets/images/jump20c.jpg"
          class="img-fluid rounded shadow"
          alt="Security Image" style="height: 400px;"
        />
      </ng-template> -->
      <ng-template carouselSlide>
        <img
          src="assets/images/jumpj.jpg"
          class="img-fluid rounded shadow"
          alt="Slide 2" style="height: 400px;"
        />
      </ng-template>
       <!-- <ng-template carouselSlide>
        <img
          src="assets/images/jump20c.jpg"
          class="img-fluid rounded shadow"
          alt="Security Image" style="height: 400px;"
        />
      </ng-template> -->
      <ng-template carouselSlide>
        <img
          src="assets/images/jump4.jpg"
          class="img-fluid rounded shadow"
          alt="Slide 3"
        />
      </ng-template>
    </owl-carousel-o>
  </div>
</section>

<section class="solutions-section py-5">
  <div class="container">
    <div class="row align-items-center">

      <!-- 📝 Text Content -->
      <div class="col-lg-7 col-md-12">
        <div class="highlight-box alt">
          <h4>WHO WE SERVE</h4>
          <p>
            CYCLOPS serves defense and government clients across the MENA region and beyond — delivering scalable, ITAR-compliant solutions in UAVs, surveillance, communications, and field operations.
          </p>

          <h5 style="padding-top: 10px;color: #b30000;">We work with:</h5>
            <p>
            <br>• Defense Ministries and Armed Forces
            <br>• Homeland Securi ty and Intelligence Agencies
            <br>• Government Contractors and Integrators
            <br>• Allied Governments and Security Institutions
</p>
       
        </div>
      </div>

      <!-- 🖼️ Image -->
      <div class="col-lg-5 col-md-12 mt-4 mt-lg-0 text-center">
        <img
          src="assets/images/jump5.jpg"
          alt="Support Image"
          class="img-fluid rounded shadow"
          style="object-fit: contain; width: 100%; height: auto;"
        />
      </div>

    </div>
  </div>
</section>

<app-cyclops-footer></app-cyclops-footer>